import React from 'react'
import { useRef } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";

export default function HomeStyle() {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true, },
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="homestyle bodygap">
        <Slider {...settings} ref={sliderRef}>
            <div>
                <div className="homestyle-box">
                    <img src="/image/homestyle-1.webp" className="img-responsive" alt="style" loading="lazy"/>
                    <div>
                        <h4 className='heading'>Style Your Child</h4>
                        <Link to={"/contemporary"} className="default-btn">Discover Now</Link>
                    </div>
                </div>
            </div>
        
            <div>
                <div className="homestyle-box">
                    <img src="/image/homestyle-2.webp" className="img-responsive" alt="style" loading="lazy"/>
                    <div>
                        <h4 className='heading'>Craft Your Dream</h4>
                        <Link to={"/wedding-dress-designers"} className="default-btn">Curate Your Look</Link>
                    </div>
                </div>
            </div>
        </Slider>
        <CustomArrows />
    </section>
    </>
  )
}
